module.exports = __webpack_public_path__ + "f243acac55bd0a9fcf0c2e77e51de68d.svg";